import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from './service/http.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService {
  user: any;
  constructor (private router: Router, private toaster: ToastrService, private http: HttpService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this.user = JSON.parse(this.http.localStorageGetItem('admin_user'));
    let redirectRoute = this.user.role;

    if (redirectRoute && next.data.role.includes(redirectRoute)) {
      return true;
    } else {
      if (next.data.page && next.data.page === 'bom-list') {
        this.router.navigate(['users']);
      } else {
        this.toaster.error("The user does not have permission to access the page.");
        this.router.navigate(['/oAuth/logout']);
      }
      return false;
    }
  }
}
